import { h, Component } from 'preact';
import { Howl, Howler } from 'howler';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/audio/audio.sss';

export default class Audio extends Component {
	constructor(props) {
		super(props);
		this.playSound = this.playSound.bind(this);
		this.state = {
			muted: false
		};
	}

	componentDidMount() {
		const { audioRoot } = this.props;
		const soundEffects = [
			'toad-coin',
			'peach-fire',
			'peach-push',
			'mario-pipe',
			'power-up',
			'count-down',
			'luigi-run',
			'mario-jump',
			'toad-stomp',
			'flower-power',
			'koopa',
			'elevator',
			'mario-smash',
			'mario-punch',
			'mario-training',
			'mario-shrink'
		];
		soundEffects.forEach(sound => {
			this[sound] = new Howl({
				src: `${audioRoot}/${sound}.mp3`
			});
		});

		Store.on('PLAY_SOUND', this.playSound);
	}

	componentWillUnmount() {
		Store.off('PLAY_SOUND', this.playSound);
	}

	playSound(sound) {
		this[sound].play();
	}

	toggleMute(mute) {
		Howler.mute(mute);
		this.setState({
			muted: mute
		});
	}

	render({ sharedImageRoot }) {
		const { muted } = this.state;
		return (
			<div class={s.container}>
				<button class={joinClasses(s.muted, !muted && s.hide)} onClick={() => this.toggleMute(false)}>
					<img src={`${sharedImageRoot}/icons/muted.png`} />
				</button>
				<button class={joinClasses(s.soundOn, muted && s.hide)} onClick={() => this.toggleMute(true)}>
					<img src={`${sharedImageRoot}/icons/soundon.png`} />
				</button>
			</div>
		);
	}
}